import { Button } from "@mui/material";
import { tracker } from "@openreplay/tracker";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import { LoadOverlay, ViewWrapper } from "@components";

import { NOTEBOOKS_EVENTS } from "@helpers/events";

import { pollingInterval } from "../constants";
import { isRestartingState } from "../helpers";
import type { StoreState } from "../state";
import { getJobs, getMe, retryJob } from "../state/api/actionCreators";
import { RequestStatus } from "../types/api";
import JobTable from "./JobTable";

const NotebooksHome = () => {
  const jobs = useSelector((state: StoreState) => state.jobs);
  const jobsRequestStatus = useSelector(
    (state: StoreState) => state.api.getJobs.status,
  );
  const shouldPollJobs = jobs
    ? jobs.some((j) => isRestartingState(j.state!))
    : false;
  const basename = useLocation().pathname;

  const dispatch = useDispatch();
  const polling = React.useRef<number>();

  const handleClickRestart = (id: string) => {
    tracker.event(NOTEBOOKS_EVENTS.NOTEBOOK_RESTART_CLICKED, id);
    dispatch(retryJob(id) as any);
    setTimeout(() => dispatch(getJobs() as any), pollingInterval);
  };

  React.useEffect(() => {
    (async () => {
      await dispatch(getMe() as any);
      await dispatch(getJobs() as any);
    })();
  }, [dispatch]);

  React.useEffect(() => {
    if (shouldPollJobs) {
      polling.current = window.setInterval(() => {
        dispatch(getJobs() as any);
      }, pollingInterval);
    } else {
      clearInterval(polling.current);
    }
  }, [dispatch, shouldPollJobs]);

  return (
    <ViewWrapper
      docsSection="NOTEBOOKS"
      title="Jupyter Notebooks"
      aboveContent={
        <Button
          color="primary"
          variant="contained"
          component={Link}
          to={`${basename}/new`}
          state={{ canGoBack: true }}
          onClick={() =>
            tracker.event(NOTEBOOKS_EVENTS.NEW_NOTEBOOK_BUTTON_CLICKED)
          }
        >
          New Notebook
        </Button>
      }
    >
      <LoadOverlay loading={jobsRequestStatus === RequestStatus?.FETCHING} />
      {jobs && <JobTable handleClickRestart={handleClickRestart} jobs={jobs} />}
    </ViewWrapper>
  );
};

export default NotebooksHome;
